<script lang="ts">
    import { slide } from 'svelte/transition';

    import { CLOSE_ICON, END_FOOT_LOGO_DOWNLOAD, STAR_IMAGE } from '../constants/imgList';
    import { JUMP_TYPE_ENUM } from '../enums';
    import { PAGE_CLICK_CK } from '../enums/track';
    import { visible } from '../store/index';
    import { handleKeyboardActivate } from '../utils/a11y';
    import { JumpLink } from '../utils/jumpTo';
    import { trackEvent } from '../utils/track';

    import webp from '@/actions/webp';
    import { pageLeave } from '@/utils/fmpTrack';

    export let bgColor = '#FFFFFF';
    export let color = '#0C0C0D';
    export let jumpColor = '#FF5F14';
    export let logo = '';
    export let closeIcon = CLOSE_ICON;
    export let isBottom = false;
    export let starImg = STAR_IMAGE;
    /** END 页顶栏 logo */
    export let useEndLogo = false;

    $: appLogo = useEndLogo ? END_FOOT_LOGO_DOWNLOAD : logo;

    export let onClose = () => {
        $visible = false;
        trackEvent(PAGE_CLICK_CK, {
            button_name: 'close'
        });
    };

    const onDownload = async () => {
        trackEvent(PAGE_CLICK_CK, {
            button_name: 'finance_app'
        });
        pageLeave();

        JumpLink(JUMP_TYPE_ENUM.TO_WEB2APP);
    };

</script>

{#if $visible && !isBottom}
    <div
        class="quick-download"
        style={`background-color:${bgColor};color:${color};`}
        out:slide={{ duration: 300 }}
        in:slide={{ duration: 300 }}
    >
        <div class="left-container">
            <img class="app-icon" src={appLogo} alt="DiDi Finanzas" use:webp={appLogo} />
            <div class="info">
                <div class="title">DiDi Finanzas: Rápido y seguro</div>
                <div class="rating-container">
                    <img src={starImg} alt="" use:webp={starImg} />
                </div>
            </div>
        </div>
        <div class="right-container">
            <div
                role="button"
                tabindex="0"
                class="download-btn"
                style={`color:${jumpColor};`}
                on:click={onDownload}
                on:keydown={(event) => handleKeyboardActivate(event, onDownload)}
            >
                Abrir
            </div>
            <div
                role="button"
                tabindex="0"
                class="close-btn"
                on:click={onClose}
                on:keydown={(event) => handleKeyboardActivate(event, onClose)}
            >
                <div class="icon" use:webp={closeIcon} />
            </div>
        </div>
    </div>
{/if}

{#if isBottom}
    <div
        class="quick-download quick-download-bottom"
        style={`background-color:${bgColor};color:${color};`}
    >
        <div class="left-container">
            <img class="app-icon" src={appLogo} alt="DiDi Finanzas" use:webp={appLogo} />
            <div class="info">
                <div class="title">DiDi Finanzas: Rápido y seguro</div>
                <div class="rating-container">
                    <img src={starImg} alt="" use:webp={starImg} />
                </div>
            </div>
        </div>
        <div class="right-container">
            <div
                role="button"
                tabindex="0"
                class="download-btn"
                style={`color:${jumpColor};`}
                on:click={onDownload}
                on:keydown={(event) => handleKeyboardActivate(event, onDownload)}
            >
                Abrir
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .quick-download {
        position: sticky;
        top: 0;
        width: 7.5rem;
        max-width: 7.5rem;
        height: 1.26rem;
        padding: 0.38rem 0.32rem 0.24rem;
        z-index: 10;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        margin: 0 auto;
        transform: translateZ(0);
    }

    .quick-download-bottom {
        position: static;
        width: auto;
        margin: 0.16rem;
        height: 1.16rem;
        padding: 0.26rem 0.32rem;
        margin-top: 20px !important;
        border-radius: 20px;
        background: #f2f2f5 !important;
    }

    .left-container {
        display: flex;
        align-items: center;
    }

    .app-icon {
        width: 0.64rem;
        height: 0.64rem;
        margin-right: 0.19rem;
    }

    .info {
        display: flex;
        flex-direction: column;
    }

    .title {
        font-size: 0.24rem;
        line-height: 0.32rem;
        font-family: DiDiSans-Pro-Bold;
    }

    .rating-container {
        display: flex;
        align-items: center;
        gap: 0.08rem;
    }

    .rating-container img {
        height: 0.2rem;
    }

    .right-container {
        display: flex;
        align-items: center;
    }

    .download-btn {
        font-size: 0.24rem;
        line-height: 0.32rem;
        font-family: DiDiSans-Pro-Bold;
        padding: 0.1rem 0;
        cursor: pointer;
    }

    .close-btn {
        padding: 0.12rem 0 0.12rem 0.12rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .close-btn .icon {
        width: 0.24rem;
        height: 0.24rem;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>
